// utils.js

// List of section IDs and paths to check against the URL hash and pathname
const sectionIDs = ["#about", "#skills", "#contact"];
const homepagePath = "/"; // Pathname for the homepage

// Function to determine if the content should be loaded immediately based on the current URL hash or pathname
export const shouldLoadContentImmediately = () => {
  return (
    sectionIDs.includes(window.location.hash) ||
    window.location.pathname === homepagePath
  );
};
